import { gql } from '@common/hooks';

export const WorksMembershipQuery = gql`
  query WorksMembership($id: ID!) {
    worksMembership(id: $id) {
      id
      active
      name
      firstName
      lastName
      email
      employeeId
      role
      timeZone
      timeZoneIdentifier
      roleName
      phone
      title
      entity: entityProvider {
        ... on Organization {
          id
          name
          organizationBusinessesActiveCount
          onDemandEnabled
          defaultTimeZone
        }
        ... on Supplier {
          id
          name
          defaultTimeZone
        }
      }
      organizationBusinessesActive {
        id
        name
        organizationUnitsActiveCount
      }
      organizationUnitsActive {
        id
        name
        organizationBusiness {
          id
          name
        }
      }
    }
  }
`;

export type WorksMembershipArgs = {
  id: string;
};

export type WorksMembershipResponse = {
  worksMembership: Membership;
};

export type WorksMembershipEntity = {
  name: string;
  organizationBusinessesActiveCount?: number;
  onDemandEnabled?: boolean;
  defaultTimeZone: string;
};

export type Membership = {
  id: string;
  active: boolean;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  employeeId: string;
  role: string;
  roleName: string;
  timeZone: string;
  timeZoneIdentifier: string;
  title: string;
  phone: string;
  updatedAt: string;
  entity: WorksMembershipEntity;
  organizationUnitsActive: MembershipOrganizationUnit[];
  organizationBusinessesActive: MembershipOrganizationBusiness[];
};

export type MembershipOrganizationBusiness = {
  id: string;
  name: string;
  organizationUnitsActiveCount: number;
};

export type MembershipOrganizationUnit = {
  id: string;
  name: string;
  organizationBusiness: {
    id: string;
    name: string;
  };
};
